import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { disabledTabMoveButton } from 'helper/index';

/**
 * 버튼 : 아이콘
 */
const IconButton = ({ icon, styleDef, viewStatus, clickEvt, error, propTabIndex, propName, starName, title }) => {
  const setPropName = propName === '' ? null : propName;
  const setTabIndex = (propName === 'left') ? -1 : (propName === 'sendBtn') ? 37567 : '';
  let ariaLabelName = '';
  let titleName = '';
  
  if(starName !== '') {
    ariaLabelName = starName
  } else if(starName === '' && setPropName === 'restart') {
    ariaLabelName = '대화 내용 초기화';
    titleName = '대화 내용 초기화';
  } else if(starName === '' && setPropName === 'sendBtn') {
    ariaLabelName = '메시지 보내기';
  } else {
    ariaLabelName = '설정 메뉴';
    titleName = '설정 메뉴';
  }

  return (
    <button type='button' className={setPropName === null ? "_at_icon_button_div" : `_at_icon_button_div ${setPropName}`} style={styleDef} tabIndex={setTabIndex} onClick={clickEvt} aria-label={ariaLabelName} title={titleName}>
{viewStatus === '_dim' ? <div className="_dim" /> : ''}
      {/* <div className="_button_div" onClick={clickEvt}> */}
      <div className="_button_div" >
        <div className="_icon">
          { icon.length >3 && icon.substring(icon.length-3) && icon.substring(0,2) !== 'ri' ? <img src={`${icon}`} alt={`${icon}`}/> : <i className={icon} style={{ color: styleDef.color }} />}
        </div>
      </div>
    </button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  clickEvt: PropTypes.func,
  error: PropTypes.object,
  propTabIndex: PropTypes.number,
  propName: PropTypes.string,
  starName: PropTypes.string,
  title: PropTypes.string,
};
IconButton.defaultProps = {
  icon: 'ri-close-fill',
  styleDef: {},
  viewStatus: '',
  clickEvt: () => {},
  error: { error: false, msg: '' },
  propTabIndex: 0,
  propName:'',
  starName:'',
  title:'',
};

export default IconButton;
